import { render, staticRenderFns } from "./BpInputFile.vue?vue&type=template&id=18a84ae6&scoped=true&"
import script from "./BpInputFile.vue?vue&type=script&lang=js&"
export * from "./BpInputFile.vue?vue&type=script&lang=js&"
import style0 from "./BpInputFile.vue?vue&type=style&index=0&id=18a84ae6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a84ae6",
  null
  
)

export default component.exports